import { TreeCollection } from '../types';

// require undviker att fork-ts-checker/tslint lintar JSON-innehållet
// tslint:disable-next-line:no-var-requires
const gt360: TreeCollection = require('./gt-360.json');

export default gt360;
